export default "__VITE_ASSET__1dcc20ee__"